import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/CreateEmailChallenge/CreateEmailChallenge";
export * from "./types/GetEmailChallenge/GetEmailChallenge";
export * from "./types/UpdateEmailChallenge/UpdateEmailChallenge";
const endpoints = {
    "ca-central-1": "https://kyc.ca-central-1.fromsmash.co",
    "eu-central-1": "https://kyc.eu-central-1.fromsmash.co",
    "eu-west-1": "https://kyc.eu-west-1.fromsmash.co",
    "eu-west-2": "https://kyc.eu-west-2.fromsmash.co",
    "eu-west-3": "https://kyc.eu-west-3.fromsmash.co",
    "us-east-1": "https://kyc.us-east-1.fromsmash.co",
    "us-east-2": "https://kyc.us-east-2.fromsmash.co",
    "us-west-1": "https://kyc.us-west-1.fromsmash.co",
    "us-west-2": "https://kyc.us-west-2.fromsmash.co",
};
config.setHosts("kyc", endpoints, false);
export class Kyc extends Client {
    constructor(params = {}) {
        super({ service: "kyc", ...params, type: "regional", userAgent: "@smash-sdk/kyc@1.0.0-alpha.5" });
        this.errors = errors;
    }
    createEmailChallenge(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/emailChallenge/:email",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        email: params["email"],
                    },
                    queryParameters: {
                        language: params["language"],
                        version: "11-2023",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateEmailChallengeError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    getEmailChallenge(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/emailChallenge/:email",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        email: params["email"],
                    },
                    queryParameters: {
                        version: "11-2023",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetEmailChallengeError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    updateEmailChallenge(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/emailChallenge/:email",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        email: params["email"],
                    },
                    queryParameters: {
                        version: "11-2023",
                    },
                    bodyParameters: {
                        token: params["token"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateEmailChallengeError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Kyc.errors = errors;
